import { h } from 'preact';

import { Link } from 'preact-router/match';
import { useEffect } from 'preact/hooks';

const KycEpisodeReview = props => {
  return (
    <nav class="nav nav-underline flex-column flex-sm-row episode-container">
      <li class="nav-item">
        <Link class={`nav-link`} activeClassName="active" href="/review/kyc">
          Personal Info
        </Link>
      </li>

      <li class="nav-item">
        <Link
          class={`nav-link`}
          activeClassName="active"
          href="/review/kyc/address"
        >
          Address
        </Link>
      </li>

      <li class="nav-item">
        <Link
          class={`nav-link`}
          activeClassName="active"
          href="/review/kyc/personal-details"
        >
          Personal Details
        </Link>
      </li>

      <li class="nav-item">
        <Link
          class={`nav-link`}
          activeClassName="active"
          href="/review/kyc/financial-profile"
        >
          Financial Profile
        </Link>
      </li>

      <li class="nav-item">
        <Link
          class={`nav-link`}
          activeClassName="active"
          href="/review/kyc/pep"
        >
          PEP
        </Link>
      </li>
      <li class="nav-item">
        <Link
          class={`nav-link`}
          activeClassName="active"
          href="/review/kyc/settlement-info"
        >
          Settlement Info
        </Link>
      </li>
    </nav>
  );
};

export default KycEpisodeReview;
